import React from 'react'

export default function TextUtils() {
    return (
        <>
            <img src={process.env.PUBLIC_URL + '/images/1589718473347.jfif'} alt="The first step is to establish that something is possible; then probability will occur. - Elon Musk" />
            <img src={process.env.PUBLIC_URL + '/images/1111946new.jpg'} alt="Eat(); Sleep(); Code(); Repeat();" style={{ height: '250px', width: '1192px' }}/>
            {/* <iframe src="https://www.github.com/PranavArya37" width="100%" height="1000px" style={{border: "1px solid black"}}>
            </iframe> */}
        </>
    )
}
